export default __webpack_public_path__ + "static/media/cover9.db3cea0b.jpeg";